import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as formValidation from './scripts/form-validation';
formValidation.init();

import * as actionChanger from '@elements/action-changer';
actionChanger.init();

